import React, { useEffect, useState } from 'react';
import { Box, CircularProgress } from '@mui/material';
import { fetchPageImageObjectUrl } from '../api/invoice-imports';
import { colors } from '../constants';

/**
 * Renders one extracted page image of an invoice import. The page endpoint is
 * auth-protected and business-scoped, so the image is fetched as an
 * authenticated blob and shown via an object URL.
 */
export default function InvoiceImportPageImage({
  uuid,
  index,
  width = 220,
  height = 300,
  onClick,
}) {
  const [url, setUrl] = useState(null);

  useEffect(() => {
    let active = true;
    let created = null;
    fetchPageImageObjectUrl(uuid, index)
      .then((objectUrl) => {
        if (active) {
          created = objectUrl;
          setUrl(objectUrl);
        } else {
          URL.revokeObjectURL(objectUrl);
        }
      })
      .catch(() => undefined);
    return () => {
      active = false;
      if (created) URL.revokeObjectURL(created);
    };
  }, [uuid, index]);

  const box = {
    width,
    height,
    borderRadius: 1,
    border: `1px solid ${colors.border}`,
    backgroundColor: colors.gray100,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    cursor: onClick ? 'pointer' : 'default',
    flexShrink: 0,
  };

  return (
    <Box sx={box} onClick={onClick}>
      {url ? (
        <img
          src={url}
          alt={`Invoice page ${index + 1}`}
          style={{ width: '100%', height: '100%', objectFit: 'contain' }}
        />
      ) : (
        <CircularProgress size={22} sx={{ color: colors.primary }} />
      )}
    </Box>
  );
}
